export enum CommunicationDisplayAlertType {
  sentDigits = 'sentDigits',
  flagServer = 'flagServer',
  blocked = 'blocked',
  null = 'null',
  inProgress = 'inProgress',
  unanswered = 'unanswered',
  spamDetected = 'spamDetected',
}
